import { getData, postData, putData } from 'src/api/http.service';
import {
  handleApiError,
  handleApiSuccess,
  generateUserInfoHeader,
  getDataFromSessionStorage,
  getAPIEndpoints,
} from 'src/utils/general.utils';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';
const CouponManageActionTypes = {
  LOAD_COUPONS_SUCCESS: '[API] : LOAD_COUPONS_SUCCESS',
  ADD_COUPON_SUCCESS: '[API] : ADD_COUPON_SUCCESS',
  UPDATE_COUPON_SUCCESS: '[API] : UPDATE_COUPON_SUCCESS',

  LOAD_CATALOGUE_SUCCESS: '[API] : LOAD_CATALOGUE_SUCCESS',
};

// plain actions*************************************************************************8

function AllCouponsSuccessAction(payload) {
  return {
    type: CouponManageActionTypes.LOAD_COUPONS_SUCCESS,
    payload,
  };
}

function CreateNewCouponSuccessAction({ data }) {
  return {
    type: CouponManageActionTypes.ADD_COUPON_SUCCESS,
    payload: { data },
  };
}

function UpdateCouponSuccessAction({ data, index }) {
  return {
    type: CouponManageActionTypes.UPDATE_COUPON_SUCCESS,
    payload: { data, index },
  };
}

function AllCatalogueSuccessAction(payload) {
  return {
    type: CouponManageActionTypes.LOAD_CATALOGUE_SUCCESS,
    payload,
  };
}

// Backend has been observed returning "no results" as an error rather than an
// empty 200 page — sometimes errorCode NO_DATA_FOUND, sometimes 1002 ("Coupon
// not found."). Either way it must render as an empty table, not stay on
// whatever the previous tab/feature successfully fetched.
const NO_DATA_ERROR_CODES = ['NO_DATA_FOUND', '1002'];

function buildEmptyCouponsPage(url) {
  const requestParams = new URLSearchParams(url.split('?')[1]);
  return {
    data: {
      content: [],
      totalElements: 0,
      totalPages: 0,
      number: Number(requestParams.get('page')) || 0,
      size: Number(requestParams.get('size')) || 0,
      first: true,
      last: true,
      empty: true,
    },
  };
}

// ASYNC actions ************************************************************************************
function GetAllCouponsAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(AllCouponsSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return response;
    } catch (err) {
      const emptyPage = buildEmptyCouponsPage(url);
      dispatch(AllCouponsSuccessAction(emptyPage));
      if (NO_DATA_ERROR_CODES.includes(err?.response?.data?.errorCode)) {
        dispatch(ApiCallSuccessAction(handleApiSuccess(emptyPage, metaData)));
      } else {
        dispatch(ApiCallFailedAction(handleApiError(err)));
      }
      return emptyPage;
    }
  };
}

function CreateNewCouponAction(url, data, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(
        url,
        data,
        generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
      );
      dispatch(CreateNewCouponSuccessAction({ data: response.data }));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return { status: true, apiRes: response };
    } catch (err) {
      console.log(err);
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return { status: false, apiRes: handleApiError(err) };
    }
  };
}

function CheckMobileNumberAction(payload, data, headers) {
  return async () => {
    try {
      const response = await getData(payload, data, headers);
      return response;
    } catch (err) {
      return handleApiError(err);
    }
  };
}

function UpdateCouponAction(data, headers, metaData) {
  const url = getAPIEndpoints().updateCoupon;
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(
        url,
        data,
        generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
      );
      dispatch(
        UpdateCouponSuccessAction({
          data: response.data,
          index: metaData?.index,
        })
      );
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return false;
    }
  };
}

function GetAllCataloguesAction(payload, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(payload);
      dispatch(AllCatalogueSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
    }
  };
}

function GetSingleCouponAction(payload, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(payload);
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return {
        status: true,
        couponDetails: response.data,
      };
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return {
        status: false,
      };
    }
  };
}

function ExpireCouponAction(payload, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(payload, null, headers);
      dispatch(UpdateCouponSuccessAction({ data: response.data, index: metaData?.index }));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return false;
    }
  };
}

export {
  CouponManageActionTypes,
  AllCouponsSuccessAction,
  CreateNewCouponSuccessAction,
  UpdateCouponSuccessAction,
  AllCatalogueSuccessAction,
  GetAllCouponsAction,
  CreateNewCouponAction,
  UpdateCouponAction,
  GetAllCataloguesAction,
  CheckMobileNumberAction,
  GetSingleCouponAction,
  ExpireCouponAction,
};
